import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const CompanyProfile = lazy(() => import("../pages/CompanyProfile"));

export const companyProfileRoutes = [
  {
    path: "/profile",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <CompanyProfile />
      </Suspense>
    ),
  },
];
